import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomIconsComponent } from './custom-icons.component';
import { HttpClientModule } from '@angular/common/http';
import { InlineSVGModule } from 'ng-inline-svg';



@NgModule({
  declarations: [
    CustomIconsComponent
  ],
  exports: [
    CustomIconsComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    InlineSVGModule.forRoot()
  ]
})
export class CustomIconsModule { }
